import { Bonus as BonusData } from '../../../../../../types/bonus';

export class Bonus {
	private _data: BonusData;
	private _reactions?: BonusData['reactions'];

	constructor(data: BonusData) {
		this._data = data;
	}

	get reactions() {
		if (!this._reactions) {
			this._reactions = this._data.reactions;
		}

		return this._reactions;
	}

	get id() {
		return this._data.id;
	}
}
